<template>
  <div class="content">
		<div class="container-fluid" style="min-height:70vh;">

    <transition name="fade-in">
      <div v-if="assessment.showModal" class="assessment-modal-overlay">
          <div class="assessment-modal">
            <div style="vertical-align: middle; display: flex; padding-bottom: 5px;">
              <span class="fas fa-cog fa-3x fa-spin"></span>
              <p style="padding-left: 15px; margin-bottom: 0; margin-top: 15px; text-transform: uppercase; font-weight: 700;">{{assessment.build_title}}</p>
            </div>
            <div>
              <p>Please, wait for this process to finish</p>
            </div>
            <div v-if="assessment.build_status" class="text-center">
              <p style="font-size:18px; font-weight:700;">Current State: {{assessment.build_status}}</p>
            </div>
            <div class="text-center">
                <!--<a v-if="assessment.build_url" style="color:white ;margin-right:10px;" class="btn btn-primary btn-fill btn-sm" :href="assessment.build_url" target="_blank">Check Logs</a>-->
                <button style="margin-left:10px;" class="btn btn-sm btn-danger btn-fill" @click="cancelAssessment()">Cancel</button>
            </div>
          </div>
      </div>
      </transition>

			<div class="row">
				<div class="col-12" style="margin-top:40px;">
					<card>
						<template class="card-header">
              <div style="display:inline-flex;">
                <router-link to="/select-option" class="btn btn-default btn-simple">
                  <i class="fa fa-arrow-left"></i> <span style="font-weight: bold; padding-left:5px; font-size:18px;" class="card-title">Back</span>
                </router-link>
              </div>
						</template>

						<template class="card-body">
              <div class="text-center col-12 col-sm-12 col-xl-8 col-lg-10 mx-auto" style="justify-content: center;margin-top:20px;">
                <h2 style="color: #76BAC6; font-weight: bold;">Take credit for the quality achievements of your code</h2>
                <h4>Fill in the form below to trigger the assessment process</h4>

                <nav class="nav nav-tabs nav-justified mt-5 mb-4" id="assessmentTypeTabs">
                    <a class="nav-link active" data-toggle="pill" data-target="#assessmentSoftwareForm" type="button">Source Code</a>
                    <a class="nav-link" data-toggle="pill" data-target="#assessmentServiceForm" type="button">Service</a>
                    <a class="nav-link" data-toggle="pill" data-target="#assessmentFairForm" type="button">FAIR</a>
                </nav>

                <div class="tab-content">

                  <div class="tab-pane fade show active" id="assessmentSoftwareForm">


                    <div class="accordion" id="softwareAccordionAssessment">
                      <div class="card">
                        <div class="card-header">
                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#softwareAssessmentFromRepository" >
                              From Repository
                            </button>
                        </div>

                        <div id="softwareAssessmentFromRepository" class="collapse show" data-parent="#softwareAccordionAssessment">
                          <div class="card-body text-left p-4">

                            <div class="row mb-2">
                              <div class="col-12 col-md-8">
                                <base-input type="text" required label="Repository URL" addon-left-icon="fa fa-archive" style="margin-bottom:0" v-model="software.repository.url" />
                                <p v-show="software.error.repository_URL" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.repository_URL }}</p>
                              </div>
                              <div class="col-12 col-md-4">
                                <base-input type="text" label="Branch" placeholder="master" addon-left-icon="fa fa-code-fork" style="margin-bottom:0" v-model="software.repository.branch" />
                              </div>
                            </div>

                            <div class="row ml-1 mb-3">

                              <base-checkbox name="software_repository_credentials" label="This is a private repository" :disabled="!software.repository.url" style="padding-left: 12px;" v-model="software.repository.private" />

                              <div v-if='software.repository.url && software.repository.private' style="margin-top: 10px; margin-bottom: 20px; padding-left:36px; padding-right: 30px;">

                                <div style="margin-top: 16px;">Personal Access Token</div>
                                <div class="custom-label">Personal access tokens are an alternative to using passwords for authentication and are intended to access resources on behalf of yourself.</div>
                                <div class="custom-label" style="margin-bottom: 12px;">Creating a personal access token documentation &#8594; <a href='https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token' target="_blank">GitHub</a> - <a href='https://docs.gitlab.com/ee/user/profile/personal_access_tokens.html' target="_blank">GitLab</a> </div>

                                <p v-show="software.error.repository_credentials" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.repository_credentials }}</p>

                                <base-input type="text" required label="GitHub/GitLab Username" addon-left-icon="fa fa-user" style="margin-left: 16px; padding-right: 14px;" v-model="software.repository.credentials.username" />

                                <base-input type="text" required concealable label="Personal Access token" addon-left-icon="fa fa-key" v-model="software.repository.credentials.access_token" style="padding-left: 16px;" />

                              </div>

                            </div>

                            <div class="row mb-2">
                              <div class="col-12 col-md-8">
                                <base-input type="text" class="no-margin" label="External documentation repository URL" addon-left-icon="fa fa-book" v-model="software.documentation.url" />
                                <p v-show="software.error.documentation_URL" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.documentation_URL }}</p>
                              </div>
                              <div class="col-12 col-md-4">
                                <base-input type="text" class="no-margin" label="Branch" placeholder="master" addon-left-icon="fa fa-code-fork" v-model="software.documentation.branch" />
                              </div>
                            </div>

                            <div class="row ml-1 mb-3">

                              <base-checkbox name="software_documentation_credentials" label="This is a private repository" :disabled="!software.documentation.url" style="padding-left: 12px;" v-model="software.documentation.private" />

                              <div v-if='software.documentation.url && software.documentation.private' style="margin-top: 16px; margin-bottom: 20px; padding-left:36px; padding-right: 30px;">

                                <div style="margin-top: 16px;">Personal Access Token</div>
                                <div class="custom-label">Personal access tokens are an alternative to using passwords for authentication and are intended to access resources on behalf of yourself.</div>
                                <div class="custom-label" style="margin-bottom: 12px;">Creating a personal access token documentation &#8594; <a href='https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token' target="_blank">GitHub</a> - <a href='https://docs.gitlab.com/ee/user/profile/personal_access_tokens.html' target="_blank">GitLab</a> </div>

                                <p v-show="software.error.documentation_credentials" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.documentation_credentials }}</p>

                                <base-input type="text" required label="GitHub/GitLab Username" addon-left-icon="fa fa-user" style="margin-left: 16px; padding-right: 14px;" v-model="software.documentation.credentials.username" />

                                <base-input type="text" required concealable label="Personal Access token" addon-left-icon="fa fa-key" v-model="software.documentation.credentials.access_token" style="padding-left: 16px;" />

                              </div>

                            </div>



                            <div class="row mb-4">
                              <div class="col-12 col-md-6">
                                <label>Choose criteria for additional customization</label>
                                  <div v-if="!software.custom_criteria.available.length" class="ssc-head-line" style="margin: 7px 0;" />
                                  <div v-else class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text"> <i class="fa fa-compass"></i> </span>
                                    </div>
                                    <select class="custom-select" v-model='software.custom_criteria.selected' >
                                      <option v-show="software.custom_criteria.selected" value="">None</option>
                                      <option style="text-transform:capitalize;" v-for="(criteria,key) in software.custom_criteria.available" :key="key" :value="criteria">{{criteria.id}}</option>
                                    </select>
                                  </div>
                              </div>
                              <div v-if="software.custom_criteria.selected" class="col-12 criteria_info">
                                <div><span class="badge badge-info">Scope</span> {{software.custom_criteria.selected.description.msg}} (<a :href="software.custom_criteria.selected.description.docs" target="_blank">more details</a>)</div>
                                <div><span class="badge badge-info">Improves</span> {{software.custom_criteria.selected.description.improves}}</div>
                              </div>
                            </div>

                            <div v-if="software.custom_criteria.selected" class="row">
                              <div class="col-12 col-md-6">
                                <label><span style="color: crimson">*</span> Choose a tool</label>
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span class="input-group-text"> <i class="fa fa-cogs"></i> </span>
                                  </div>
                                  <select class="custom-select" v-model='software.custom_criteria.tool.selected_name' >
                                    <option style="text-transform:capitalize;" v-for="(tool,key) in software.custom_criteria.tool.available" :key="key" :value="tool['name']">{{tool['name'].toUpperCase()}}</option>
                                  </select>
                                </div>
                                <p v-show="software.error.tool_selection" style="color:red; font-size:12px; padding-top:6px; padding-left:0;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.tool_selection }}</p>
                              </div>
                            </div>

                            <div v-if="software.custom_criteria.tool.selected_name">

                              <div class="row mt-3">
                                <div class="col-12">
                                  <span v-if="software.custom_criteria.tool.custom_image" class="badge badge-secondary" style="margin-right: 5px;">image:<span style="font-weight:bold;"> {{software.custom_criteria.tool.custom_image}}</span></span>
                                  <span v-else-if="software.custom_criteria.tool.docker_image" class="badge badge-secondary" style="margin-right: 5px;">image:<span style="font-weight:bold;"> {{software.custom_criteria.tool.docker_image}}</span></span>
                                  <span v-if="!software.custom_criteria.tool.custom_image && software.custom_criteria.tool.docker_lang" class="badge badge-primary" style="margin:0 6px;">lang:<span style="font-weight:bold"> {{software.custom_criteria.tool.docker_lang}}</span></span>
                                  <span v-if="!software.custom_criteria.tool.custom_image && software.custom_criteria.tool.docker_version" class="badge badge-danger" style="margin:0 6px;">version:<span style="font-weight:bold"> {{software.custom_criteria.tool.docker_version}}</span></span>
                                </div>
                              </div>

                              <div class="row mt-3 mx-1">
                                <div class="col-12">

                                <p v-show="software.error.tool_args" style="color:red; font-size:12px; padding-left:0; padding-top:14px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.tool_args }}</p>
                                <div v-for="arg in software.custom_criteria.tool.selected.args" :key="arg.id" style="margin-top: 16px;">
                                  <div v-if="arg.selectable">

                                    <div v-if="!arg.repeatable && arg.format === 'string'" class="form-group">
                                      <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" />
                                    </div>

                                    <div v-else-if="arg.repeatable && arg.format === 'string'" class="form-group">
                                      <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" tags />
                                    </div>

                                    <div v-else-if="!arg.repeatable && arg.format === 'array'" class="form-group">
                                      <label :for="arg.id"><span v-if="arg.type === 'positional'" style="color: crimson">*</span> {{arg.description}}</label>
                                      <select class="custom-select" :id="arg.id">
                                        <option selected disabled value=''></option>
                                        <option v-for="opt in arg.value" :key="opt" :value="opt">{{opt}}</option>
                                      </select>
                                    </div>

                                  </div>
                                </div>

                                <base-input type="text" label="Custom public image" help="Define your own image service. This has to be public." :placeholder="software.custom_criteria.tool.docker_image" v-model="software.custom_criteria.tool.custom_image" />

                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>


                      <div class="card">
                        <div class="card-header">
                            <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#softwareAssessmentFromJSON" >
                              Load QAA report from previous assessment
                            </button>
                        </div>

                        <div id="softwareAssessmentFromJSON" class="collapse"  data-parent="#softwareAccordionAssessment">
                          <div class="card-body">

                            <div class="text-left mb-4">

                            <div class="row mt-2 mb-2"><div class="col">You can review a previously generated SQAaaS report </div></div>
                            <p v-show="software.error.json" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.json }}</p>

                            <div class="row my-2"><div class="col ml-4 custom-label">By uploading the associated JSON file</div></div>

                            <div class="custom-file text-center">
                              <input type="file" accept="application/JSON" id="softwareJSONInputFile" class="custom-file-input" title="" @dragenter="dragEnterJSON($event.target)" @dragleave="dragLeaveJSON($event.target)" @change="selectJSON($event.target,'software')">
                              <label class="custom-file-label" :class="{ 'json-loaded': software.json.file }">{{ software.json.file? software.json.file.name+" ("+Math.round(software.json.file.size/1024)+"kB)" : "Select or drop an assessment report JSON file" }}</label>
                              <p v-show="software.error.json_file" style="color:red; font-size:12px;padding-left:0; padding-top:10px; text-align: left"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.json_file }}</p>
                            </div>

                            <div class="row my-2"><div class="col ml-4 custom-label">By typing the URL of the JSON file</div></div>

                            <div class="custom-file text-center">
                              <base-input type="text" v-model="software.json.url" @input="inputURLJSON($event.target, 'software')" />
                              <p v-show="software.error.json_url" style="color:red; font-size:12px; margin-top:-8px; text-align: left"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ software.error.json_url }}</p>
                            </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <button class="btn btn-primary btn-fill mb-3 startAssessmentButton" :disabled="software.accordion_open === 'none'" @click="startAssessment('software')">Start Source Code Assessment</button>


                  </div>

                  <div class="tab-pane fade" id="assessmentServiceForm">

                    <div class="accordion" id="serviceAccordionAssessment">
                      <div class="card">
                        <div class="card-header">
                          <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#serviceAssessmentFromRepository" >
                            From Repository
                          </button>
                        </div>

                        <div id="serviceAssessmentFromRepository" class="collapse show" data-parent="#serviceAccordionAssessment">
                          <div class="card-body text-left p-4">

                              <div class="row mb-2">
                                <div class="col-12 col-md-8">
                                  <base-input type="text" required class="no-margin" label="Repository URL" addon-left-icon="fa fa-archive" v-model="service.repository.url" />
                                  <p v-show="service.error.repository_URL" style="color:red; font-size:12px; padding-top:6px; padding-left:0;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.repository_URL }}</p>
                                </div>
                                <div class="col-12 col-md-4">
                                  <base-input type="text" class="no-margin" label="Branch" placeholder="master" addon-left-icon="fa fa-code-fork"  v-model="service.repository.branch" />
                                </div>
                              </div>

                              <div class="row ml-1 mb-3">

                                <base-checkbox name="service_repository_credentials" label="This is a private repository" :disabled="!service.repository.url" style="padding-left: 12px;" v-model="service.repository.private" />

                                <div v-if='service.repository.private' style="margin-top: 16px; margin-bottom: 20px; padding-left:36px; padding-right: 30px;">

                                  <div style="margin-top: 16px;">Personal Access Token</div>
                                  <div class="custom-label">Personal access tokens are an alternative to using passwords for authentication and are intended to access resources on behalf of yourself.</div>
                                  <div class="custom-label" style="margin-bottom: 12px;">Creating a personal access token documentation &#8594; <a href='https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token' target="_blank">GitHub</a> - <a href='https://docs.gitlab.com/ee/user/profile/personal_access_tokens.html' target="_blank">GitLab</a> </div>

                                  <p v-show="service.error.repository_credentials" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.repository_credentials }}</p>

                                  <base-input type="text" required label="GitHub/GitLab Username" addon-left-icon="fa fa-user" style="margin-left: 16px; padding-right: 14px;" v-model="service.repository.credentials.username" />

                                  <base-input type="text" required concealable label="Personal Access token" addon-left-icon="fa fa-key" v-model="service.repository.credentials.access_token" style="padding-left: 16px;" />

                                </div>

                              </div>

                              <div class="row">
                                <div class="col-12 col-md-6">
                                  <label><span style="color: crimson">*</span> Choose a tool </label>
                                  <div v-if="!service.tool.available.length" class="ssc-head-line" style="margin: 7px 0;" />
                                  <div v-else class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text"> <i class="fa fa-cogs"></i> </span>
                                    </div>
                                    <select class="custom-select" v-model='service.tool.selected_name' >
                                      <option style="text-transform:capitalize;" v-for="(tool,key) in service.tool.available" :key="key" :value="tool['name']">{{tool['name'].toUpperCase()}}</option>
                                    </select>
                                  </div>
                                  <p v-show="service.error.tool_selection" style="color:red; font-size:12px; padding-top:6px; padding-left:0;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.tool_selection }}</p>
                                </div>
                              </div>

                              <div v-if="service.tool.selected_name">

                                <div class="row mt-3">
                                  <div class="col-12">
                                    <span v-if="service.tool.custom_image" class="badge badge-secondary" style="margin-right: 5px;">image:<span style="font-weight:bold;"> {{service.tool.custom_image}}</span></span>
                                    <span v-else-if="service.tool.docker_image" class="badge badge-secondary" style="margin-right: 5px;">image:<span style="font-weight:bold;"> {{service.tool.docker_image}}</span></span>
                                    <span v-if="!service.tool.custom_image && service.tool.docker_lang" class="badge badge-primary" style="margin:0 5px;">lang:<span style="font-weight:bold"> {{service.tool.docker_lang}}</span></span>
                                    <span v-if="!service.tool.custom_image && service.tool.docker_version" class="badge badge-danger" style="margin:0 5px;">version:<span style="font-weight:bold"> {{service.tool.docker_version}}</span></span>
                                  </div>
                                </div>

                                <div class="row mt-3 mx-1">
                                  <div class="col-12">

                                    <p v-show="service.error.tool_args" style="color:red; font-size:12px; padding-left:0; padding-top:14px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.tool_args }}</p>
                                    <div v-for="arg in service.tool.selected.args" :key="arg.id" style="margin-top: 16px;">
                                      <div v-if="arg.selectable">

                                        <div v-if="!arg.repeatable && arg.format === 'string'" class="form-group">
                                          <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" />
                                        </div>

                                        <div v-else-if="arg.repeatable && arg.format === 'string'" class="form-group">
                                          <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" tags />
                                        </div>

                                        <div v-else-if="!arg.repeatable && arg.format === 'array'" class="form-group">
                                          <label :for="arg.id"><span v-if="arg.type === 'positional'" style="color: crimson">*</span> {{arg.description}}</label>
                                          <select class="custom-select" :id="arg.id">
                                            <option selected disabled value=''></option>
                                            <option v-for="opt in arg.value" :key="opt" :value="opt">{{opt}}</option>
                                          </select>
                                        </div>

                                      </div>
                                    </div>

                                    <base-input type="text" label="Custom public image" help="Define your own image service. This has to be public." :placeholder="service.tool.docker_image" v-model="service.tool.custom_image" />

                                  </div>
                                </div>

                              </div>

                          </div>
                        </div>
                      </div>


                      <div class="card">
                        <div class="card-header">
                          <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#serviceAssessmentFromJSON" >
                            Load QAA report from previous assessment
                          </button>
                        </div>

                        <div id="serviceAssessmentFromJSON" class="collapse"  data-parent="#serviceAccordionAssessment">
                          <div class="card-body">

                            <div class="text-left mb-4">

                              <div class="row mt-2 mb-2"><div class="col">You can review a previously generated SQAaaS report </div></div>
                              <p v-show="service.error.json" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.json }}</p>

                              <div class="row my-2"><div class="col ml-4 custom-label">By uploading the associated JSON file</div></div>

                              <div class="custom-file text-center">
                                <input type="file" accept="application/JSON" id="serviceJSONInputFile" class="custom-file-input" title="" @dragenter="dragEnterJSON($event.target)" @dragleave="dragLeaveJSON($event.target)" @change="selectJSON($event.target,'service')">
                                <label class="custom-file-label" :class="{ 'json-loaded': service.json.file }">{{ service.json.file? service.json.file.name+" ("+Math.round(service.json.file.size/1024)+"kB)" : "Select or drop an assessment report JSON file" }}</label>
                                <p v-show="service.error.json_file" style="color:red; font-size:12px;padding-left:0; padding-top:10px; text-align: left"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.json_file }}</p>
                              </div>

                              <div class="row my-2"><div class="col ml-4 custom-label">By typing the URL of the JSON file</div></div>

                              <div class="custom-file text-center">
                                <base-input type="text" v-model="service.json.url" @input="inputURLJSON($event.target, 'service')" />
                                <p v-show="service.error.json_url" style="color:red; font-size:12px; margin-top:-8px; text-align: left"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ service.error.json_url }}</p>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <button class="btn btn-primary btn-fill mb-3 startAssessmentButton" :disabled="service.accordion_open === 'none'" @click="startAssessment('service')">Start Service Assessment</button>

                  </div>

                  <div class="tab-pane fade" id="assessmentFairForm">

                    <div class="accordion" id="fairAccordionAssessment">
                      <div class="card">
                        <div class="card-header">
                          <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#fairAssessmentFromRepository" >
                            From Repository
                          </button>
                        </div>

                        <div id="fairAssessmentFromRepository" class="collapse show" data-parent="#fairAccordionAssessment">
                          <div class="card-body text-left p-4">

                                <div class="row">
                                  <div class="col-12 col-md-6">
                                    <label><span style="color: crimson">*</span> Choose a tool</label>
                                    <div v-if="!fair.tool.available.length" class="ssc-head-line" style="margin: 7px 0;" />
                                    <div v-else class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text"> <i class="fa fa-cogs"></i> </span>
                                      </div>
                                      <select class="custom-select" v-model='fair.tool.selected_name'>
                                        <option style="text-transform:capitalize;" v-for="(tool,key) in fair.tool.available" :key="key" :value="tool['name']">{{tool['name'].toUpperCase()}}</option>
                                      </select>
                                    </div>
                                    <p v-show="fair.error.tool_selection" style="color:red; font-size:12px; padding-top:6px; padding-left:0;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ fair.error.tool_selection }}</p>
                                  </div>
                                </div>

                                <div v-if="fair.tool.selected_name">

                                  <div class="row mt-3">
                                    <div class="col-12">
                                      <span v-if="fair.tool.custom_image" class="badge badge-secondary" style="margin-right: 5px;">image:<span style="font-weight:bold;"> {{fair.tool.custom_image}}</span></span>
                                      <span v-else-if="fair.tool.docker_image" class="badge badge-secondary" style="margin-right: 5px;">image:<span style="font-weight:bold;"> {{fair.tool.docker_image}}</span></span>
                                      <span v-if="!fair.tool.custom_image && fair.tool.docker_lang" class="badge badge-primary" style="margin:0 5px;">lang:<span style="font-weight:bold"> {{fair.tool.docker_lang}}</span></span>
                                      <span v-if="!fair.tool.custom_image && fair.tool.docker_version" class="badge badge-danger" style="margin:0 5px;">version:<span style="font-weight:bold"> {{fair.tool.docker_version}}</span></span>
                                    </div>
                                  </div>

                                  <div class="row mt-3 mx-1">
                                    <div class="col-12">

                                      <p v-show="fair.error.tool_args" style="color:red; font-size:12px; padding-left:0; padding-top:14px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ fair.error.tool_args }}</p>
                                      <div v-for="arg in fair.tool.selected.args" :key="arg.id" style="margin-top: 16px;">
                                        <div v-if="arg.selectable">

                                          <div v-if="!arg.repeatable && arg.format === 'string'" class="form-group">
                                            <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" />
                                          </div>

                                          <div v-else-if="arg.repeatable && arg.format === 'string'" class="form-group">
                                            <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" tags />
                                          </div>

                                          <div v-else-if="!arg.repeatable && arg.format === 'array'" class="form-group">
                                            <label :for="arg.id"><span v-if="arg.type === 'positional'" style="color: crimson">*</span> {{arg.description}}</label>
                                            <select class="custom-select" :id="arg.id">
                                              <option selected disabled value=''></option>
                                              <option v-for="opt in arg.value" :key="opt" :value="opt">{{opt}}</option>
                                            </select>
                                          </div>

                                        </div>
                                      </div>

                                      <base-input type="text" label="Custom public image" help="Define your own image service. This has to be public." :placeholder="fair.tool.docker_image" v-model="fair.tool.custom_image" />

                                    </div>
                                  </div>

                                 </div>

                          </div>
                        </div>
                      </div>


                      <div class="card">
                        <div class="card-header">
                          <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#fairAssessmentFromJSON" >
                            Load QAA report from previous assessment
                          </button>
                        </div>

                        <div id="fairAssessmentFromJSON" class="collapse"  data-parent="#fairAccordionAssessment">
                          <div class="card-body">

                            <div class="text-left mb-4">

                              <div class="row mt-2 mb-2"><div class="col">You can review a previously generated SQAaaS report </div></div>
                              <p v-show="fair.error.json" style="color:red; font-size:12px;padding-left:0; padding-top:6px;"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ fair.error.json }}</p>

                              <div class="row my-2"><div class="col ml-4 custom-label">By uploading the associated JSON file</div></div>

                              <div class="custom-file text-center">
                                <input type="file" accept="application/JSON" id="fairJSONInputFile" class="custom-file-input" title="" @dragenter="dragEnterJSON($event.target)" @dragleave="dragLeaveJSON($event.target)" @change="selectJSON($event.target,'fair')">
                                <label class="custom-file-label" :class="{ 'json-loaded': fair.json.file }">{{ fair.json.file? fair.json.file.name+" ("+Math.round(fair.json.file.size/1024)+"kB)" : "Select or drop an assessment report JSON file" }}</label>
                                <p v-show="fair.error.json_file" style="color:red; font-size:12px;padding-left:0; padding-top:10px; text-align: left"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ fair.error.json_file }}</p>
                              </div>

                              <div class="row my-2"><div class="col ml-4 custom-label">By typing the URL of the JSON file</div></div>

                              <div class="custom-file text-center">
                                <base-input type="text" v-model="fair.json.url" @input="inputURLJSON($event.target, 'fair')" />
                                <p v-show="fair.error.json_url" style="color:red; font-size:12px; margin-top:-8px; text-align: left"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ fair.error.json_url }}</p>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>




                    <button class="btn btn-primary btn-fill mb-3 startAssessmentButton" :disabled="fair.accordion_open === 'none'" @click="startAssessment('fair')">Start FAIR Assessment</button>

                  </div>

                </div>

              </div>
						</template>
					</card>
				</div>

			</div>
		</div>
  </div>
</template>

<script>

  import Card from 'src/components/Cards/Card.vue';
  import Services from '../services/services';

  export default {

    components: {Card},

    mixins: [Services],

    data () {
      return {
        apiVersion: undefined,
        api_criteria: [],

        software: {

          accordion_open: 'repository', // 'repository' | 'json' | 'none'

          repository: {
            url: '',
            branch: '',
            private: false,
            credentials:{
              username: '',
              access_token: ''
            }
          },

          documentation: {
            url: '',
            branch: '',
            private: false,
            credentials: {
              username: '',
              access_token: ''
            }
          },

          custom_criteria: {
            available: [], // For now, only 'QC.Uni'. Defined in getCriteriaCallBack()
            selected: undefined,
            tool: {
              available: [],
              selected_name : undefined,
              selected: undefined,
              docker_image: undefined,
              docker_lang: undefined,
              docker_version: undefined,
              custom_image: ''
            }
          },

          json: {
            file: undefined,
            url: '',
          },

          error: {
            repository_URL: '', // Field 'Repository URL' empty or not URL format
            repository_credentials: '', // Repository credentials not provided
            documentation_URL: '', // Field 'Documentation URL' not URL format
            documentation_credentials: '', // Documentation credentials not provided
            tool_selection: '', // Tool not selected
            tool_args: '', // Required tool arguments not provided
            json: '', // JSON file or URL not provided
            json_file: '', // Invalid JSON file (error reading, bad syntax, invalid schema)
            json_url: '', // Invalid JSON file (error connecting, bad syntax, invalid schema)
          }
        },

        service: {

          criteria: 'SvcQC.Dep', // Always 'SvcQC.Dep'
          accordion_open: 'repository', // 'repository' | 'json' | 'none'

          repository: {
            url: '',
            branch: '',
            private: false,
            credentials:{
              username: '',
              access_token: ''
            }
          },

          documentation: {
            url: '',
            branch: '',
            private: false,
            credentials: {
              username: '',
              access_token: ''
            }
          },

          tool:{
            available: [],
            selected_name: undefined,
            selected: undefined,
            docker_image: undefined,
            docker_lang: undefined,
            docker_version: undefined,
            custom_image: ''
          },

          json: {
            file: undefined,
            url: '',
          },

          error: {
            repository_URL: '', // Field 'Repository URL' empty or not URL format
            credentials: '', // Credentials not provided
            tool_selection: '', // Tool not selected
            tool_args: '', // Required tool arguments not provided
            json: '', // JSON file or URL not provided
            json_file: '', // Invalid JSON file (error reading, bad syntax, invalid schema)
            json_url: '', // Invalid JSON file (error connecting, bad syntax, invalid schema)
          }

        },

        fair: {

          criteria: 'QC.FAIR', // Always 'QC.FAIR'
          accordion_open: 'repository', // 'repository' | 'json' | 'none'

          tool:{
            available: [],
            selected_name: undefined,
            selected: undefined,
            docker_image: undefined,
            docker_lang: undefined,
            docker_version: undefined,
            custom_image: ''
          },

          json: {
            file: undefined,
            url: '',
          },

          error: {
            tool_selection: '', // Tool not selected
            tool_args: '', // Required tool arguments not provided
            json: '', // JSON file or URL not provided
            json_file: '', // Invalid JSON file (error reading, bad syntax, invalid schema)
            json_url: '', // Invalid JSON file (error connecting, bad syntax, invalid schema)
          }

        },

        assessment:{
          showModal: false,
          autoRefresh: false,
          pipeline_id: undefined,
          build_title : undefined,
          build_status: undefined,
          build_url: undefined
        }

      }
    },

    created(){
      this.getCriteriaCall(this.getCriteriaCallBack, true);
    },
    mounted(){

      $('[data-toggle="tooltip"]').tooltip()
      $('body').tooltip({selector: '.dynamic_tooltip'})

      $('#softwareAssessmentFromRepository').on('shown.bs.collapse', () => { this.software.accordion_open = 'repository' })
                                            .on('hide.bs.collapse',  () => { this.software.accordion_open = 'none'       })
      $('#softwareAssessmentFromJSON')      .on('shown.bs.collapse', () => { this.software.accordion_open = 'json'       })
                                            .on('hide.bs.collapse',  () => { this.software.accordion_open = 'none'       })

      $('#serviceAssessmentFromRepository').on('shown.bs.collapse', () => { this.service.accordion_open = 'repository' })
                                           .on('hide.bs.collapse',  () => { this.service.accordion_open = 'none'       })
      $('#serviceAssessmentFromJSON')      .on('shown.bs.collapse', () => { this.service.accordion_open = 'json'       })
                                           .on('hide.bs.collapse',  () => { this.service.accordion_open = 'none'       })

      $('#fairAssessmentFromRepository').on('shown.bs.collapse', () => { this.fair.accordion_open = 'repository' })
                                        .on('hide.bs.collapse',  () => { this.fair.accordion_open = 'none'       })
      $('#fairAssessmentFromJSON')      .on('shown.bs.collapse', () => { this.fair.accordion_open = 'json'       })
                                        .on('hide.bs.collapse',  () => { this.fair.accordion_open = 'none'       })

      $('#softwareAssessmentFromJSON, #serviceAssessmentFromJSON, #fairAssessmentFromJSON').on('show.bs.collapse', () => {
        if(!this.apiVersion) {
          let openapiURL = ''
          if (process.env.VUE_APP_API === "https://api.sqaaas.eosc-synergy.eu/v1") openapiURL = "https://api.sqaaas.eosc-synergy.eu/v1/openapi.json"
          if (process.env.VUE_APP_API === "https://api-staging.sqaaas.eosc-synergy.eu/v1" ||
              process.env.VUE_APP_API === "https://api-dev.sqaaas.eosc-synergy.eu") openapiURL = "https://api-staging.sqaaas.eosc-synergy.eu/v1/openapi.json"

          $.getJSON(openapiURL)
            .done((json) => {
              this.apiVersion = json.info.version;
              console.log("API Version: "+this.apiVersion)
            })
        }
      });

   },

    watch:{
      'software.custom_criteria.selected'(selected_criteria){
        this.software.custom_criteria.tool.selected_name = undefined
        this.software.custom_criteria.tool.available = selected_criteria ? this.api_criteria.find(criteria => criteria.id === selected_criteria.id)['tools'] : []
      },
      'software.custom_criteria.tool.selected_name'(tool_name){
        if(tool_name){
          this.software.custom_criteria.tool.selected = this.software.custom_criteria.tool.available.find(tool => tool.name === tool_name)

          this.software.custom_criteria.tool.custom_image = ''
          this.software.custom_criteria.tool.docker_image = (this.software.custom_criteria.tool.selected && this.software.custom_criteria.tool.selected.docker && this.software.custom_criteria.tool.selected.docker.image) ? this.software.custom_criteria.tool.selected.docker.image : (this.software.custom_criteria.tool.selected && this.software.custom_criteria.tool.selected.docker && this.software.custom_criteria.tool.selected.docker.dockerfile)?'Dockerfile':''
          this.software.custom_criteria.tool.docker_lang = (this.software.custom_criteria.tool.selected && this.software.custom_criteria.tool.selected.lang) ? this.software.custom_criteria.tool.selected.lang : ''
          this.software.custom_criteria.tool.docker_version = (this.software.custom_criteria.tool.selected && this.software.custom_criteria.tool.selected.version) ? this.software.custom_criteria.tool.selected.version : ''

        }else{
          this.software.custom_criteria.tool.custom_image = ''
          this.software.custom_criteria.tool.docker_image = '';
          this.software.custom_criteria.tool.docker_lang = '';
          this.software.custom_criteria.tool.docker_version = '';
        }
      },
      'service.tool.selected_name'(tool_name){
        if(tool_name){
          this.service.tool.selected = this.service.tool.available.find(tool => tool.name === tool_name)

          this.service.tool.custom_image = ''
          this.service.tool.docker_image = (this.service.tool.selected && this.service.tool.selected.docker && this.service.tool.selected.docker.image) ? this.service.tool.selected.docker.image : (this.service.tool.selected && this.service.tool.selected.docker && this.service.tool.selected.docker.dockerfile)?'Dockerfile':''
          this.service.tool.docker_lang = (this.service.tool.selected && this.service.tool.selected.lang) ? this.service.tool.selected.lang : ''
          this.service.tool.docker_version = (this.service.tool.selected && this.service.tool.selected.version) ? this.service.tool.selected.version : ''

        }else{
          this.service.tool.custom_image = ''
          this.service.tool.docker_image = '';
          this.service.tool.docker_lang = '';
          this.service.tool.docker_version = '';
        }
      },
      'fair.tool.selected_name'(tool_name){
        if(tool_name){
          this.fair.tool.selected = this.fair.tool.available.find(tool => tool.name === tool_name)

          this.fair.tool.custom_image = ''
          this.fair.tool.docker_image = (this.fair.tool.selected && this.fair.tool.selected.docker && this.fair.tool.selected.docker.image) ? this.fair.tool.selected.docker.image : (this.fair.tool.selected && this.fair.tool.selected.docker && this.fair.tool.selected.docker.dockerfile)?'Dockerfile':''
          this.fair.tool.docker_lang = (this.fair.tool.selected && this.fair.tool.selected.lang) ? this.fair.tool.selected.lang : ''
          this.fair.tool.docker_version = (this.fair.tool.selected && this.fair.tool.selected.version) ? this.fair.tool.selected.version : ''

        }else{
          this.fair.tool.custom_image = ''
          this.fair.tool.docker_image = '';
          this.fair.tool.docker_lang = '';
          this.fair.tool.docker_version = '';
        }
      },

      'assessment.autoRefresh'(val) {
        if (val)
          this.t = setInterval(() => { this.checkStatus() }, 10 * 1000)
        else
          clearInterval(this.t)
      }
    },

    methods:{
      getCriteriaCallBack(response){

        if(response.status === 200){ // 200 OK
          this.api_criteria = response.data
          // OLD this.software.custom_criteria.available = ['QC.Uni']
          this.software.custom_criteria.available = [this.api_criteria.find(criteria => criteria.id === 'QC.Uni')]
          this.service.tool.available = this.api_criteria.find(criteria => criteria.id === this.service.criteria)['tools']
          this.fair.tool.available = this.api_criteria.find(criteria => criteria.id === this.fair.criteria)['tools']
        }else{
          this.$swal.fire({
            title: 'We are having problems making the request.',
            html: '<div style="font-size: 0.85em">' + response.status + " " + response.statusText + " " + response.config.method.toUpperCase() + " " + response.config.url + '</div>' +
                  '<div style="margin-top: 1.5em">Please, try again in a few minutes.</div>',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
            footer: '<a style="font-size:18px;color:red; text-decoration:underline;"  href="https://github.com/EOSC-synergy/SQAaaS/issues/new/choose" target="_blank">Report the issue</a>',
          }).then(() => {
            this.$router.push('select-option');
          })
        }

      },

      dragEnterJSON(target){
        $(target).parent().children('label').addClass('drag-enter')
      },
      dragLeaveJSON(target){
        $(target).parent().children('label').removeClass('drag-enter')
      },
      selectJSON(target, assessmentType){

        this[assessmentType].error.json = '';
        this[assessmentType].error.json_file = '';
        this[assessmentType].error.json_url = '';
        this[assessmentType].json.url = ''

        $(target).parent().children('label').removeClass('drag-enter')
        let file = target.files[0]

        const reader = new FileReader();

        reader.onload = (res) => {
          try {
            let json = JSON.parse(res.target.result);
            if(!json.repository || !json.report || !json.badge){
              this[assessmentType].json.file = ''
              this[assessmentType].error.json_file = 'Invalid report schema. Only SQAaaS report files are valid.'
            }
            else {
              this[assessmentType].json.file = file
              this[assessmentType].error.json_file = ''
            }
          }
          catch (error) {
            this[assessmentType].json.file = ''
            this[assessmentType].error.json_file = 'Invalid JSON syntax. Only JSON files are valid.'
          }
        }

        reader.onerror = (err) => {
          this[assessmentType].json.file = ''
          this[assessmentType].error.json_file = 'Error reading file'
        }

        reader.readAsText(file);

      },
      inputURLJSON(target, assessmentType){

        this[assessmentType].json.file = '';
        $('#'+assessmentType+'JSONInputFile')[0].value = null;

      },

      checkAPIVersion(json) {
          let reportVersion = json.meta && json.meta.version;
          let apiVersion = this.apiVersion;
          if (!apiVersion || !reportVersion || parseInt(reportVersion.split('.')[0]) >= parseInt(apiVersion.split('.')[0])) return true
          //if (!apiVersion || (reportVersion && parseInt(reportVersion.split('.')[0]) >= parseInt(apiVersion.split('.')[0]) )) return true
          else {
            this.$swal.fire({
              title: 'Assessment report version obsolete',
              text: 'The report version is too old ' + (reportVersion? '('+reportVersion+') ' : '') + 'and is no longer compatible with SQAaaS, which needs at least version '+apiVersion.split('.')[0]+'.0.0',
              icon: 'error',
              confirmButtonText: 'Ok',
              confirmButtonColor: '#E14726',
            })
            return false
          }
      },
      startAssessment(assessmentType){

        console.log('%c----%c startAssessment(\''+assessmentType+'\')', 'color: goldenrod','')

        Object.keys(this.software.error).forEach((key)=>{this.software.error[key] = ''})
        Object.keys(this.service.error).forEach((key)=>{this.service.error[key] = ''})
        Object.keys(this.fair.error).forEach((key)=>{this.fair.error[key] = ''})

        this.assessment.autoRefresh = false
        this.assessment.pipeline_id = undefined
        this.assessment.build_title = undefined
        this.assessment.build_status = undefined
        this.assessment.build_url = undefined

        let data = {}
        let url_pattern_regex = /^(https:|http:|www\.)\S*/;


        if (assessmentType === 'software'){

          if(this.software.accordion_open === 'repository') {

            if (this.software.repository.url.trim() === '') {
              this.software.error.repository_URL = 'This field is required';
              return
            }

            if (!url_pattern_regex.test(this.software.repository.url.trim())) {
              this.software.error.repository_URL = 'URL format required';
              return
            }

            if(this.software.repository.private){
              if(!this.software.repository.credentials.username || !this.software.repository.credentials.access_token){
                this.software.error.repository_credentials = 'Credentials are required';
                return
              }
            }

            if (this.software.documentation.url.trim() !== '' && !url_pattern_regex.test(this.software.documentation.url.trim())) {
              this.software.error.documentation_URL = 'URL format required';
              return
            }

            if(this.software.documentation.private){
              if(!this.software.documentation.credentials.username || !this.software.documentation.credentials.access_token){
                this.software.error.documentation_credentials = 'Credentials are required';
                return
              }
            }

            if(this.software.custom_criteria.selected){
              if(!this.software.custom_criteria.tool.selected_name){
                this.software.error.tool_selection = 'A tool is required when a criteria is customized'
                return
              }
            }

            if(this.software.custom_criteria.tool.selected){
              if(this.software.custom_criteria.tool.selected.args.some( arg => arg.type === 'positional' && arg.value === '')){
                this.software.error.tool_args = "Required arguments not filled out"
                return
              }
            }

            data = {
              repo_code: {
                repo: this.software.repository.url.trim()
              }
            }

            if (this.software.repository.branch.trim()){
              data.repo_code.branch = this.software.repository.branch.trim()
            }
            if (this.software.repository.private){
              data.repo_code.credentials_id = {
                user_id: this.software.repository.credentials.username.trim(),
                token: this.software.repository.credentials.access_token.trim()
              }
            }

            if(this.software.documentation.url.trim()){
              data.repo_docs = {
                repo: this.software.documentation.url.trim()
              }
              if(this.software.documentation.branch.trim()){
                data.repo_docs.branch = this.software.documentation.branch.trim()
              }
              if(this.software.documentation.private){
                data.repo_docs.credentials_id = {
                  user_id: this.software.documentation.credentials.username.trim(),
                  token: this.software.documentation.credentials.access_token.trim()
                }
              }
            }

            if(this.software.custom_criteria.tool.selected){
              if(this.software.custom_criteria.tool.custom_image){
                let custom_tool = {
                  name: this.software.custom_criteria.tool.selected.name,
                  docker: { image: this.software.custom_criteria.tool.custom_image },
                  args: this.software.custom_criteria.tool.selected.args
                }
                data.criteria_workflow = [{
                  "id": this.software.custom_criteria.available[0],
                  "tools": [custom_tool]
                }]
              }
              else{
                data.criteria_workflow = [{
                  "id": this.software.custom_criteria.available[0],
                  "tools": [this.software.custom_criteria.tool.selected]
                }]
              }
            }


            this.assessment.showModal = true
            this.assessment.build_title = 'Submitting Pipeline...'
            console.log('%c<---%c createAssessmentPipelineCall()','color: red','')
            console.log(data)
            this.createAssessmentPipelineCall(data, this.createAssessmentPipelineCallBack)
          }

          else if (this.software.accordion_open === 'json'){

            if(!this.software.json.file && !this.software.json.url){
              this.software.error.json = 'A JSON file is required';
              return
            }

            if (this.software.json.file){

              const reader = new FileReader();

              reader.onload = (res) => {
                let json = JSON.parse(res.target.result);
                if (this.checkAPIVersion(json)) {
                  this.$store.state.report = json;
                  this.goToReport();
                }
              }

              reader.readAsText(this.software.json.file);

            }
            else if (this.software.json.url){

              if (!url_pattern_regex.test(this.software.json.url.trim())) {
                this.software.error.json_url = 'URL format required';
                return
              }
              let json_pattern_regex = /\S*\.json$/;
              if (!json_pattern_regex.test(this.software.json.url.trim())) {
                this.software.error.json_url = 'URL must end in .json';
                return
              }

              $.getJSON(this.software.json.url)
                .done((json) => {

                  if(!json.repository || !json.report || !json.badge){
                    this.software.error.json_url = 'Invalid report schema. Only SQAaaS report files are valid.'
                  }
                  else {
                    if (this.checkAPIVersion(json)) {
                      this.$store.state.report = json;
                      this.goToReport();
                    }
                  }
                })
                .fail((jqxhr, textStatus, error) => {
                  if(textStatus === 'parsererror') this.software.error.json_url = 'Invalid JSON syntax. Only JSON files are valid.';
                  else this.software.error.json_url = 'Connection Error: The JSON file could not be retrieved';
              })

            }

          }
        }
        else if (assessmentType === 'service'){

          if(this.service.accordion_open === 'repository') {

            if (this.service.repository.url.trim() === '') {
              this.service.error.repository_URL = 'This field is required';
              return
            }

            if (!url_pattern_regex.test(this.service.repository.url.trim())) {
              this.service.error.repository_URL = 'URL format required';
              return
            }

            if(this.service.repository.private){
              if(!this.service.repository.credentials.username || !this.service.repository.credentials.access_token){
                this.service.error.repository_credentials = 'Credentials are required';
                return
              }
            }

            if (!this.service.tool.selected) {
              this.service.error.tool_selection = 'You must select a tool to define some pipeline work';
              return
            }

            if(this.service.tool.selected){
              if(this.service.tool.selected.args.some( arg => arg.type === 'positional' && arg.value === '')){
                this.service.error.tool_args = "Required arguments not filled out"
                return
              }
            }

            data = {
              deployment: {
                repo_deploy: {
                  repo: this.service.repository.url.trim(),
                }
              }
            }
            if (this.service.repository.branch.trim()){
              data.deployment.repo_deploy.branch = this.service.repository.branch.trim()
            }
            if (this.service.repository.private){
              data.deployment.repo_deploy.credentials_id = {
                user_id: this.service.repository.credentials.username.trim(),
                token: this.service.repository.credentials.access_token.trim()
              }
            }

            if(this.service.tool.custom_image){
              let custom_tool = {
                name: this.service.tool.selected.name,
                docker: { image: this.service.tool.custom_image },
                args: this.service.tool.selected.args
              }
              data.deployment.deploy_tool = custom_tool
            }
            else{
              data.deployment.deploy_tool = this.service.tool.selected
            }


            this.assessment.showModal = true;
            this.assessment.build_title = 'Submitting Pipeline...';
            console.log('%c<---%c createAssessmentPipelineCall()','color: red','')
            console.log(data)
            this.createAssessmentPipelineCall(data, this.createAssessmentPipelineCallBack)
          }
          else if (this.service.accordion_open === 'json'){

            if (!this.service.json.file && !this.service.json.url){
              this.service.error.json = 'A JSON file is required'
              return
            }

            if (this.service.json.file){

                const reader = new FileReader();

                reader.onload = (res) => {
                  let json = JSON.parse(res.target.result);
                  if (this.checkAPIVersion(json)) {
                    this.$store.state.report = json;
                    this.goToReport();
                  }
                }

                reader.readAsText(this.service.json.file);

            }
            else if (this.service.json.url){

              if (!url_pattern_regex.test(this.service.json.url.trim())) {
                this.service.error.json_url = 'URL format required';
                return
              }
              let json_pattern_regex = /\S*\.json$/;
              if (!json_pattern_regex.test(this.service.json.url.trim())) {
                this.service.error.json_url = 'URL must end in .json';
                return
              }

              $.getJSON(this.service.json.url)
                .done((json) => {

                  if(!json.repository || !json.report || !json.badge){
                    this.service.error.json_url = 'Invalid report schema. Only SQAaaS report files are valid.'
                  }
                  else {
                    if (this.checkAPIVersion(json)) {
                      this.$store.state.report = json
                      this.goToReport();
                    }
                  }
                })
                .fail((jqxhr, textStatus, error) => {
                  if(textStatus === 'parsererror') this.service.error.json_url = 'Invalid JSON syntax. Only JSON files are valid.';
                  else this.service.error.json_url = 'Connection Error: The JSON file could not be retrieved';
              })

            }

          }
        }
        else if (assessmentType === 'fair'){

          if(this.fair.accordion_open === 'repository') {

            if(!this.fair.tool.selected){
              this.fair.error.tool_selection = 'You must select a tool to define some pipeline work';
              return
            }

            if(this.fair.tool.selected){
              if(this.fair.tool.selected.args.some( arg => arg.type === 'positional' && arg.value === '')){
                this.fair.error.tool_args = "Required arguments not filled out"
                return
              }
            }

            if(this.fair.tool.custom_image){
              let custom_tool = {
                name: this.fair.tool.selected.name,
                docker: { image: this.fair.tool.custom_image },
                args: this.fair.tool.selected.args
              }
              data = {
                fair: {
                  fair_tool: custom_tool
                }
              }
            }
            else{
              data = {
                fair: {
                  fair_tool: this.fair.tool.selected
                }
              }
            }


            this.assessment.showModal = true;
            this.assessment.build_title = 'Submitting Pipeline...';
            console.log('%c<---%c createAssessmentPipelineCall()','color: red','')
            console.log(data)
            this.createAssessmentPipelineCall(data, this.createAssessmentPipelineCallBack)

          }
          else if (this.fair.accordion_open === 'json'){

            if (!this.fair.json.file && !this.fair.json.url){
              this.fair.error.json = 'A JSON file is required'
              return
            }

            if (this.fair.json.file){

              const reader = new FileReader();

              reader.onload = (res) => {
                let json = JSON.parse(res.target.result);
                if (this.checkAPIVersion(json)) {
                  this.$store.state.report = json;
                  this.goToReport();
                }
              }

              reader.readAsText(this.fair.json.file);

            }
            else if (this.fair.json.url){

              if (!url_pattern_regex.test(this.fair.json.url.trim())) {
                this.fair.error.json_url = 'URL format required';
                return
              }
              let json_pattern_regex = /\S*\.json$/;
              if (!json_pattern_regex.test(this.fair.json.url.trim())) {
                this.fair.error.json_url = 'URL must end in .json';
                return
              }

              $.getJSON(this.fair.json.url)
                .done((json) => {

                  if(!json.repository || !json.report || !json.badge){
                    this.fair.error.json_url = 'Invalid report schema. Only SQAaaS report files are valid.'
                  }
                  else {
                    if (this.checkAPIVersion(json)) {
                      this.$store.state.report = json;
                      this.goToReport();
                    }
                  }
                })
                .fail((jqxhr, textStatus, error) => {
                  if(textStatus === 'parsererror') this.fair.error.json_url = 'Invalid JSON syntax. Only JSON files are valid.';
                  else this.fair.error.json_url = 'Connection Error: The JSON file could not be retrieved';
              })

            }

          }
        }

      },
      createAssessmentPipelineCallBack(response){
        console.log('%c--->%c createAssessmentPipelineCallBack()','color: lime','')
        console.log(response)

        if(!this.assessment.showModal) return

        if(response && response.status === 201 && response.data.id){ // 201 Created
          this.assessment.pipeline_id = response.data.id;
          console.log('%c<---%c runAssessmentPipelineCall()','color: red','')
          console.log(this.assessment.pipeline_id)
          this.runAssessmentPipelineCall(this.assessment.pipeline_id,this.runAssessmentPipelineCallBack)
        }
        else if(response && response.status === 500){ // 500 Internal Server Error
          this.$swal.fire({
            title: 'An unexpected error occurred while running the assessment!',
            text: response.detail? response.detail : response.reason? response.reason : response.data? response.data.status+" "+response.data.title+": "+response.data.detail : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
        else{
           this.$swal.fire({
            title: 'The quality assessment has failed to complete!',
            text: response? (response.detail? response.detail : response.reason? response.reason : response.data? response.data : 'Error') : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
      },
      runAssessmentPipelineCallBack(response){
        console.log('%c--->%c runAssessmentPipelineCallBack()','color: lime','')
        console.log(response)

        if(!this.assessment.showModal) return

        if(response.status === 204){ // 204 No Content
          this.assessment.autoRefresh = true;
        }
        else if(response.status === 403){ // 403 Forbidden
          this.logout_egi()
        }
        else if(response.status === 500){ // 500 Internal Server Error
          this.$swal.fire({
            title: 'An unexpected error occurred while running the assessment!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data.status + " " + response.data.title + ": " + response.data.detail : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
        else{
          this.$swal.fire({
            title: 'The quality assessment has failed to complete!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }

      },
      checkStatus(){
        this.assessment.build_title = 'Executing Pipeline...'
        console.log('%c<---%c checkStatus()','color: red','')
        console.log(this.assessment.pipeline_id)
        this.checkStatusCall(this.assessment.pipeline_id,this.checkStatusCallBack)
      },
      checkStatusCallBack(response){
        console.log('%c--->%c checkStatusCallBack()','color: lime','')
        console.log(response)

        if(!this.assessment.showModal) return

        if(response.status === 200){ // 200 OK

          this.assessment.build_url = response.data.build_url;

          if (response.data.build_status.toUpperCase() !== 'NOT_EXECUTED'){
            this.assessment.build_status = response.data.build_status;
          }

          if(response.data.build_status.toUpperCase() === 'SUCCESS' || response.data.build_status.toUpperCase() === 'UNSTABLE'){
            this.assessment.autoRefresh = false;
            console.log('%c<---%c getOutputCall()', 'color: red', '')
            console.log(this.assessment.pipeline_id)
            this.getOutputCall(this.assessment.pipeline_id, this.getOutputCallBack);
          }

          if(response.data.build_status.toUpperCase() === "FAILURE" || response.data.build_status.toUpperCase() === "ABORTED"){
            this.$swal.fire({
              title: 'The execution of the pipeline has failed!',
              icon: 'error',
              confirmButtonText: 'Close',
              confirmButtonColor: '#E14726',
              footer: `<a style='color:red' href="${this.assessment.build_url}" target="_blank">Why do I have this issue?</a>`
            })
            this.closeAssessmentModal()
          }
        }
        else if(response.status === 403){ // 403 Forbidden
          this.logout_egi()
        }
        else if (response.status === 422){ // 422 Unprocessable Entity
          this.$swal.fire({
            title: 'Pipeline has not been execute!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
        else if(response.status === 500){ // 500 Internal Server Error
          this.$swal.fire({
            title: 'The quality assessment has failed to complete!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
          })
          this.closeAssessmentModal()
        }
        else{
          this.$swal.fire({
            title: 'Error!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<a href="${this.assessment.build_url}" target="_blank">Why do I have this issue?</a>`
          })
          this.closeAssessmentModal()
        }
      },
      getOutputCallBack(response){
        console.log('%c--->%c getOutputCallBack()','color: lime','')
        console.log(response)

        if(!this.assessment.showModal) return

        if(response.status === 200){ // 200 OK
          this.$store.state.report = response.data;
          console.log('%c----%c goToReport()', 'color: goldenrod','')
          this.goToReport();
        }
        else if(response.status === 403){ // 403 Forbidden
          this.logout_egi()
        }
        else if(response.status === 500){ // 500 Internal Server Error
          this.$swal.fire({
            title: 'An unexpected error occurred while running the assessment!',
            text: response.detail? response.detail : response.reason? response.reason : response.data? response.data.status+" "+response.data.title+": "+response.data.detail : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
        else{
          this.$swal.fire({
            title: 'The quality assessment has failed to complete!',
            text: response.detail? response.detail : response.reason? response.reason : response.data? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
      },
      goToReport(){
        this.$router.push({name: 'full-assessment-report'});
      },
      cancelAssessment(){
        if(!this.assessment.pipeline_id)
          console.log('%c----%c cancelAssessment()','color: goldenrod','')
        else{
          console.log('%c----%c cancelAssessment(\'' + this.assessment.pipeline_id + '\')','color: goldenrod','')

          if(!(this.assessment.build_status === 'SUCCESS') && !(this.assessment.build_status === 'UNSTABLE')){  // undefined | 'NOT_EXECUTED' | 'EXECUTING'
            console.log('%c<---%c deletePipelineCall()', 'color: red', '')
            console.log(this.assessment.pipeline_id)
            this.deletePipelineCall(this.assessment.pipeline_id, this.deletePipelineCallBack)
          }
        }

        this.$swal.fire({
          title: 'Assessment cancelled',
          html: 'Assessment for repository <b>'+this.software.repository.url+'</b> successfully cancelled.',
          icon: 'success',
          confirmButtonText: 'Close',
          confirmButtonColor: '#3085d6',
        })

        this.closeAssessmentModal()
      },
      deletePipelineCallBack(response){
        console.log('%c--->%c deletePipelineCallBack()','color: lime','')
        console.log(response)
      },
      closeAssessmentModal(){
        this.assessment.showModal    = false
        this.assessment.autoRefresh  = false
        this.assessment.pipeline_id  = undefined
        this.assessment.build_title  = undefined
        this.assessment.build_status = undefined
        this.assessment.build_url    = undefined
      }
    }
  }

</script>


<style scoped>

  .custom-label{
    padding-top:5px;
    padding-left:6px;
    color: #9A9A9A;

  }
  input[type=number]::-webkit-inner-spin-button {
    opacity: 1;
  }

  .no-margin{
    margin:0 !important;
  }

  .custom-append-button {
    padding-top: 0 !important;
    padding-bottom: 0.38rem !important;
    padding-left:0.75rem !important;
    padding-right:0.75rem !important;
      margin-bottom: 0;
      font-size: 1rem;
      font-weight: 400;
      /* line-height: 1.5; */
      color: #495057;
      /* text-align: center; */
      /* white-space: nowrap; */

      border: none;

      height: 40px;
  }

  .btn-info {
      border-color: #1185EB;
      color: #1185EB;
  }

  .btn-next {
      background-color: #1DC7EA !important;
      color: black !important;
      padding:1rem 0 1rem 0;
      font-weight: bold;
      border: 2px solid black;
    }

  .btn-next-back{
    width: 20%!important;
  }

  .btn-back{
    padding:1rem 0 1rem 0;
    background-color:#ccc!important;
    margin-right:10%;
    font-weight: bold;
    border: 2px solid black;

  }
  .custom-div-append {
    padding:0 0 0 0;
    margin:0;
    margin-left: -3px;
  }

  .criteria_info{
    margin-top: 0.5em;
    margin-left: 0.5em;
    div { margin-top: 0.5em; }
  }


  @media (max-width: 576px) {
    .container-fluid{
      padding-left: 0!important;
      padding-right: 0!important;
    }
  }

  .accordion-head i{
    font-size: 1.5em;
    float: right;
  }

  .accordion-head > .collapsed > i:before{
      content: "\f105";
  }

  @media (min-width: 992px){
      .col-lg-10 {
          -ms-flex: 0 0 83.333333%;
          -webkit-box-flex: 0;
          flex: 0 0 83.333333%;
          max-width: 100%;
    }
  }

  @media (min-width: 1200px) {
    .col-lg-10 {
        -ms-flex: 0 0 83.333333%;
        -webkit-box-flex: 0;
        flex: 0 0 83.333333%;
        max-width: 70%;
    }
  }

  .custom-table-title{
    padding-top:5px;
    /* padding-left:20px; */
    text-transform: uppercase;
    font-size:16px;
    color:black;
    font-weight:700;
  }

  .modal-dialog{
    transform:none!important;
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  #assessmentTypeTabs .nav-link.active{
    background-color: #3472F7 !important;
    color: white !important;
    font-weight: bold !important;
    font-size: larger;
  }

  #assessmentSoftwareForm,
  #assessmentServiceForm,
  #assessmentFairForm{
    padding-left: 35px;
    padding-right: 35px;
  }

  .accordion{
    margin-bottom: 30px;
  }

  .accordion .collapsing{
    position: relative;
    height: 0;
    overflow: hidden;
    transition: height .35s ease;
  }

  .accordion .card{
    margin: 0;
  }

  .accordion .card-header{
    padding: 0.75rem 1.25rem;
    background-color: rgba(0,0,0,.03);
    border-bottom: 1px solid rgba(0,0,0,.125) !important;
  }

  .accordion .card-header .btn{
    border: none;
    padding: 0.375rem 0.75rem;
  }
  .accordion .card-header .btn-link{
    color: #007bff;
    text-decoration: none;

  }
  .accordion .card-header .btn-link:after{
    content: "\f077";
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    float: right;
  }

  .accordion .card-header .btn-link.collapsed:after{
    content: "\f078";
  }

  .accordion .custom-file{
    width: 90%;
    margin: 10px 2.5rem;
  }
  .accordion .custom-file-label{
    border: 1px solid #E3E3E3;
  }

  .accordion .custom-file input{
      cursor: pointer;
  }

  .accordion .custom-file label{
      font-size: 16px;
      padding-right: 90px;
  }
  .accordion .custom-file label.drag-enter{
      background: #fff6e1;
  }
  .accordion .custom-file label.json-loaded:not(.drag-enter){
      background: #e2fae2;
  }

  .startAssessmentButton:disabled{
    cursor: not-allowed;
  }

  .assessment-modal-overlay {
    display: flex;
    background: rgba(240, 240, 240, 0.4);
    backdrop-filter: blur(3px);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9998;
    align-items: center;
    justify-content: center;
  }

  .assessment-modal{
    padding: 26px 46px;
    background-color: #ccc;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.3) 0 15px 38px, rgba(0, 0, 0, 0.22) 0 12px 12px;
    will-change: transform; /* Prevent blur on scaling */
  }

  .fade-in-enter-active{
    transition: opacity 0.2s;
  }
  .fade-in-enter-active .assessment-modal{
    transition: transform 0.2s;
  }
  .fade-in-enter{
    opacity: 0;
  }
  .fade-in-enter .assessment-modal{
    transform: scale(0.7);
  }
</style>
<style>
  .swal2-backdrop-show {
    backdrop-filter: blur(3px);
  }
</style>

